import { useState } from "react";
import { Box, IconButton, Paper, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { alienParasite } from "theme/palette";

const STORAGE_KEY = "hoppenhagen-season-break-dismissed";

const readDismissed = (): boolean => {
  try {
    return sessionStorage.getItem(STORAGE_KEY) === "1";
  } catch {
    return false;
  }
};

export const SeasonBreakBanner = () => {
  const [dismissed, setDismissed] = useState(readDismissed);

  if (dismissed) return null;

  const handleDismiss = () => {
    try {
      sessionStorage.setItem(STORAGE_KEY, "1");
    } catch {
      // storage unavailable, banner simply reappears on next load
    }
    setDismissed(true);
  };

  return (
    <Paper
      role="status"
      elevation={0}
      sx={{
        position: "fixed",
        top: { xs: 72, sm: 84 },
        left: "50%",
        transform: "translateX(-50%)",
        width: "min(92vw, 640px)",
        zIndex: (theme) => theme.zIndex.modal,
        bgcolor: "primary.main",
        color: "common.white",
        borderRadius: 3,
        borderLeft: `6px solid ${alienParasite.main}`,
        boxShadow: "0 12px 40px rgba(0,0,0,0.45)",
        px: { xs: 2.5, sm: 4 },
        py: { xs: 2, sm: 2.5 },
        display: "flex",
        alignItems: "center",
        gap: 2,
        "@keyframes seasonBreakIn": {
          from: { opacity: 0, transform: "translate(-50%, -12px)" },
          to: { opacity: 1, transform: "translate(-50%, 0)" },
        },
        animation: "seasonBreakIn 0.5s ease-out",
      }}
    >
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography
          component="p"
          sx={{
            fontWeight: 900,
            fontSize: { xs: 17, sm: 21 },
            lineHeight: 1.25,
            letterSpacing: -0.2,
          }}
        >
          We're taking a break this season
        </Typography>
        <Typography
          sx={{
            mt: 0.5,
            fontWeight: 500,
            fontSize: { xs: 13, sm: 15 },
            lineHeight: 1.5,
            opacity: 0.9,
          }}
        >
          Classes are paused for now. We'll be back jumping in 2027. See you
          then!
        </Typography>
      </Box>
      <IconButton
        onClick={handleDismiss}
        aria-label="Dismiss announcement"
        size="small"
        sx={{
          color: "common.white",
          flexShrink: 0,
          "&:hover": { bgcolor: "rgba(255,255,255,0.15)" },
        }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Paper>
  );
};
